Pixlee.module("GridsApp.Grid", function(Grid, App, Backbone, Marionette, $) {
    var _this = this,
        API;


    Grid.Layout = App.Views.Layout.extend({
        template: require('./template/_grid_layout.jst.ejs'),
        id: 'photos_container',
        regions: {
            photos_region: '#photos_region',
            photowall_footer_region: '#footer_region',
            selector_region: '#grid_selector'
        }
    });
    Grid.Text = App.Views.ItemView.extend({
        tagName: 'p',
        template: require('./template/_grid_text.jst.ejs'),
        onRender: function() {
            this.$el.find('.user-text-wrapper').show();
        }
    });
    Grid.Source = App.Views.ItemView.extend({
        tagName: 'div',
        template: require('./template/_grid_source.jst.ejs'),
        onRender: function() {
            this.$el.find('.source_icon').show();
        },
        templateHelpers: function() {
            var _this = this;
            return _.extend({
                getSourceIcon: function() {
                    return _this.model.get('source');
                }
            }, App.request("concern", "PhotoHelpers"));
        }
    });
    Grid.Text.include(["PhotoViewHelpers"]);
    Grid.Item = App.Views.ItemView.extend({
        template: require('./template/_grid_item.jst.ejs'),
        className: 'grid-item',
        ui: {
            'pinPhoto': '.pin_photo',
            'nextPin': '.next_pin',
            'prevPin': '.prev_pin',
            'buttonsContainer': '.pin_buttons',
            'pin': '.pinning',
            'video': 'video' // target all videos inside the ItemView
        },
        events: {
            'click @ui.pinPhoto': 'clickPin',
            'click @ui.nextPin': 'switchPin',
            'click @ui.prevPin': 'switchPin'
        },
        onShow: function() {
            this.triggerMethod('set:end:of:video:listener');
        },
        onSetEndOfVideoListener: function() {
            // When the video ends, reset thumbnail to beginning of video
            this.ui.video.one('ended',function() {
                $(this).fadeOut();
            });
        },
        onRemovePin: function() {
            this.ui.pin.remove();
        },
        clickPin: function() {
            var _this = this;
            this.$el.toggleClass('pinned');
            this.ui.pinPhoto.toggleClass('active');
            this.ui.buttonsContainer.toggleClass('active');
            var cb = function() {
                _this.trigger('changed:pinned');
            };
            this.ui.pinPhoto.hasClass('active') ? this.switchPin() : this.changeImage(cb);
        },
        switchPin: function(e) {
            var _this = this;
            var cb = function() {
                _this.trigger('changed:pinned');
            };
            var index = gon.starredPhotos.findIndex(function(photo) {
                return photo.get('album_photo_id') === _this.model.get('album_photo_id');
            });
            var next_index = 0;

            if (e && e.target.className === 'prev_pin') {
                next_index = (index - 1) % gon.starredPhotos.length;
                if (next_index < 0) {
                    next_index *= -1;
                }
            } else {
                next_index = (index + 1) % gon.starredPhotos.length;
            }
            this.changeImageTo(gon.starredPhotos[next_index], true, cb);
        },
        initialize: function() {
            this.on('change:image', this.changeImage, this);
            this.on('play:video', this.playVideo, this);
        },
        handlePlayVideo: function(playEl, source, mediaId) {
            gon.videoPlaying = true;
            this.$el.addClass('gt-playing');
            this.$el.removeClass('gt-waiting');
            if (source === 'youtube') {
                this.initializeYoutubeVideo(mediaId, playEl);
            } else {
                var playPromise = _.isFunction(playEl.play) ? playEl.play() : undefined;
                // Catch and handle the error if a video can't play
                if (playPromise !== undefined) {
                    playPromise.catch(function(error) {
                        gon.videoPlaying = false;
                        this.$el.removeClass('gt-playing gt-waiting');
                        this.$el.addClass('gt-played');
                    }.bind(this));
                }
            }
        },
        initializeYoutubeVideo: function(mediaId, el) {
            var containerEl = this.$el;
            var player = new YT.Player(el, {
                height: '500',
                width: '500',
                videoId: mediaId,
                host: 'https://www.youtube.com',
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                },
                playerVars: {
                    rel: 0
                }
            });

            function onPlayerReady(event) {
                event.target.mute();
                event.target.playVideo();
            }
            function onPlayerStateChange(event) {
                // Video has finished playing
                if(event.data === 0) {
                    player.destroy();
                    gon.videoPlaying = false;
                    containerEl.removeClass('gt-playing');
                    containerEl.removeClass('gt-waiting');
                    containerEl.addClass('gt-played');
                }
            }
        },
        onRender: function() {
            var _this = this;
            _this.speed = 1000;
            if (Modernizr.touch && this.model.get('content_type') === 'video') {
                _this.newImage();
            }

            if (this.model.get('content_type') === 'video') {
                var source = this.model.get('source');
                var playEl = this.$el.find('.box_bg_image.active');
                if (!gon.videoPlaying) {
                    if (source === 'youtube') {
                        playEl = playEl.find('.pixlee_youtube_video');
                    } else {
                        playEl = playEl.find('.pixlee_video');
                    }
                    this.handlePlayVideo(playEl[0], source, this.model.get('media_id'));
                } else {
                    this.$el.addClass('gt-waiting');
                }
            } else {
                this.$el.find('.box_image.active').imagesLoaded().done(function() {
                    _this.$el.find('.box_bg_image.active').css('opacity', '1');
                }).fail(function() {
                    _this.newImage();
                });
            }

            this.$el.find('.pixlee_video').on('ended', function() {
                _this.$el.removeClass('gt-playing');
                _this.$el.removeClass('gt-waiting');
                _this.$el.addClass('gt-played');
                gon.videoPlaying = false;
            });
            this.textView = new Grid.Text({
                model: this.model
            });
            this.sourceView = new Grid.Source({
                model: this.model
            });
            _this.$el.find('.box_bg_image.active').append(this.textView.$el);
            _this.$el.find('.box_bg_image.active').append(this.sourceView.$el);
            this.textView.render();
            this.sourceView.render();
            this.activeTextView = 'textView';
            this.activeSourceView = 'sourceView';

            this.textViewTwo = new Grid.Text({
                model: this.model
            });
            this.sourceViewTwo = new Grid.Source({
                model: this.model
            });
            _this.$el.find('.box_bg_image').not('.active').append(this.textViewTwo.$el);
            _this.$el.find('.box_bg_image').not('.active').append(this.sourceViewTwo.$el);
            this.textViewTwo.render();
            this.sourceViewTwo.render();
            _this.$el.cycle({
                speed: _this.speed,
                timeout: 0,
                fx: gon.grid_params.animation,
                slides: '.box_bg_image'
            });

            if (this.$el.hasClass('pinned')) {
                this.ui.pinPhoto.addClass('active');
                this.ui.buttonsContainer.addClass('active');
            }
        },
        newImage: function() {
            var _this = this;
            if (gon.fresh_images.length === 0) {
                setTimeout(function() {
                    _this.newImage();
                }, 100);
            } else {
                var objImage = new Image();

                _this.model = gon.fresh_images[0];
                gon.fresh_images.shift();
                objImage.onLoad = function() {
                    _this.render();
                }();

                objImage.src = this.model.get('source_url');
            }
        },
        changedAnimation: function() {
            this.$el.cycle('destroy');
            this.render();
        },
        playVideo: function() {
            var source = this.model.get('source');
            var mediaId = this.model.get('media_id');
            if (!gon.videoPlaying) {
                var playEl = this.$el.find('.box_bg_image.active');
                if (source === 'youtube') {
                    playEl = playEl.find('.pixlee_youtube_video');
                } else {
                    playEl = playEl.find('.pixlee_video');
                }
                this.handlePlayVideo(playEl[0], source, mediaId);
            } else {
                this.$el.removeClass('gt-playing');
                this.$el.removeClass('gt-played');
                this.$el.addClass('gt-waiting');
            }
        },
        changeImageTo: function(model, ignoreDuplicates, callback) {
            var _this = this;
            if (_.isFalsy(model)) {
                if (!_.isFalsy(callback)) {
                    callback();
                }
                return false;
            }

            _this.model = model;

            if (_.isFalsy(ignoreDuplicates) && $('.gt-visible').find('.box_bg_image.active[data-id="' + _this.model.get('album_photo_id') + '"]').length > 0) {
                console.log($('.box_bg_image.active[data-id="' + _this.model.get('album_photo_id') + '"]').length);
                console.log(_this.model.get('album_photo_id'));
                console.log('dup!');
                if (!_.isFalsy(callback)) {
                    callback();
                }
                return false;
            }

            var activeBg = _this.$el.find('.box_image.active');
            var activeImg = _this.$el.find('.box_bg_image.active');
            var inactiveBg = _this.$el.find('.box_bg_image').not('.active');
            var inactiveImg = _this.$el.find('.box_image').not('.active');

            if (_this.model.get('data_file_name') && this.model.get('content_type') !== 'video') {
                var hostName = "https://static.pxlecdn.com";
                var url = hostName + "/photos/" + (_this.model.get('id') || _this.model.get('photo_id')) + "/original/" + App.reqres.request("encode:utf8", _this.model.get('data_file_name'));
                _this.model.set('source_url', url);
            }

            inactiveBg.attr('data-id', _this.model.get('album_photo_id'));
            if (this.model.get('content_type') === 'video') {
                var thumbnailUrl = this.model.get('medium_url').replace('http://', 'https://');
                inactiveBg.css('background-image', 'url('+thumbnailUrl+')');

                if (this.model.get('source') !== 'youtube') {
                    var video = inactiveBg.find('.pixlee_video');
                    video.attr('src', _this.model.get('source_url'));
                    video[0].load();
                }

                inactiveImg.addClass('active');
                inactiveBg.addClass('active');
                activeImg.removeClass('active');
                activeBg.removeClass('active');

                inactiveBg.find('.header-unit').show();

                _this.activeTextView = (_this.activeTextView === 'textView') ? 'textViewTwo' : 'textView';
                _this.activesourceView = (_this.activesourceView === 'sourceView') ? 'sourceViewTwo' : 'sourceView';

                _this[_this.activeTextView].$el.find('.user-text-wrapper').hide();
                _this[_this.activeSourceView].$el.find('.source_icon').hide();

                setTimeout(function() {
                    _this.$el.cycle('next');
                }, 50);

                setTimeout(function() {
                    _this[_this.activeTextView].model = _this.model;
                    _this[_this.activeTextView].render();
                    _this[_this.activeSourceView].model = _this.model;
                    _this[_this.activeSourceView].render();
                    _this.playVideo();
                }, _this.speed);

            } else {
                inactiveImg.attr('src', _this.model.get('source_url').replace('http://', 'https://'));
                inactiveImg.imagesLoaded().done(function() {

                    inactiveBg.css('background-image', 'url(' + _this.model.get('source_url').replace('http://', 'https://') + ')').addClass('active');
                    inactiveImg.addClass('active');
                    activeImg.removeClass('active');
                    activeBg.removeClass('active');
                    inactiveBg.find('.header-unit').hide();

                    _this.activeTextView = (_this.activeTextView === 'textView') ? 'textViewTwo' : 'textView';
                    _this.activesourceView = (_this.activesourceView === 'sourceView') ? 'sourceViewTwo' : 'sourceView';

                    _this[_this.activeTextView].$el.find('.user-text-wrapper').hide();
                    _this[_this.activeSourceView].$el.find('.source_icon').hide();

                    setTimeout(function() {
                        _this.$el.cycle('next');
                    }, 50);

                    setTimeout(function() {

                        _this[_this.activeTextView].model = _this.model;
                        _this[_this.activeTextView].render();
                        _this[_this.activeSourceView].model = _this.model;
                        _this[_this.activeSourceView].render();
                    }, _this.speed);
                }).fail(function() {
                    console.log('error loading images');
                });
            }

            if (!_.isFalsy(callback)) {
                callback();
            }
        },
        changeImage: function(callback) {
            if (this.$el.hasClass('pinned')) {
                return false;
            }
            this.changeImageTo(gon.fresh_images[0], false, callback);
            gon.fresh_images.shift();
        },
        templateHelpers: function() {
            var _this = this;
            return _.extend({
                isVideo: function() {
                    if (_this.model.get('content_type') === 'video') {
                        return true;
                    }
                },
                isStory: function() {
                    return _this.model.get('subtype') === 'instagram_story';
                },
                videoUrl: function() {
                    if (_this.model.get('source_url')) {
                        return _this.model.get('source_url');
                    }
                },
                getVideoThumbnailUrl: function() {
                    var mediumUrl = _this.model.get('medium_url');
                    return mediumUrl ? mediumUrl.replace('http://', 'https://') : '';
                }
            }, App.request("concern", "PhotoHelpers"));
        }
    });

    Grid.Selector = App.Views.ItemView.extend({
        id: "gt-grid-selector",
        className: 'gt-grid-control',
        template: require('./template/_grid_selector.jst.ejs'),
        initialize: function() {
            this.on('changed:pin:url', this.changedPinURL, this);
        },
        events: {
            'change #grid_interval_speed': 'changeInterval',
            'change #grid_transition_animation': 'changeAnimation',
            'change #grid_offline_mode': 'changeMode',
            'keyup #grid_bottom_text textarea': 'changeText'
        },
        changedPinURL: function() {
            var encodedPinned = btoa(JSON.stringify(gon.grid_params.pinned));
            $('#pinned_param').text(encodedPinned);
        },
        changeInterval: function(e) {
            var value = $(e.currentTarget).find('option:selected').attr('value');
            gon.grid_params.interval = parseInt(value);
            $('#interval_param').text(gon.grid_params.interval);
        },
        changeAnimation: function(e) {
            var value = $(e.currentTarget).find('option:selected').attr('value');
            gon.grid_params.animation = value;
            App.commands.execute('changed:animation');
            $('#animation_param').text(gon.grid_params.animation);
        },
        changeMode: function(e) {
            var value = $(e.currentTarget).find('option:selected').attr('value');
            gon.grid_params.offlineMode = value === "true";

            if (!gon.grid_params.offlineMode) {
                gon.refreshIterations = gon.refreshTime / gon.grid_params.interval;
            }

            $('#offline_mode_param').text(gon.grid_params.offlineMode);
        },
        changeText: function(e) {
            clearTimeout(this.timer);
            var text = $(e.currentTarget).val().trim();
            if (text.length === 0) text = '';
            this.timer = setTimeout(function() {
                if (gon.marquee && gon.marquee.marquee) {
                    gon.marquee.marquee('destroy');
                    gon.marquee = null;
                }
                $('.js-marquee').css('float', '');
                $('#hashtag_text').html(text);
                gon.grid_params.action_text = text;
                $('#action_text_param').text(encodeURIComponent(gon.grid_params.action_text));
                setTimeout(function() {
                    if ($('#hashtag_holder')[0].scrollWidth > $('#hashtag_holder').innerWidth()) {
                        gon.marquee = $('#hashtag_holder').marquee({
                            duration: 10000
                        });
                    }
                }, 300);
            }, 500);

        },
        onShow: function() {
            if (Modernizr.touch) {
                $('#grid_icon').css('opacity', '0');
            }
            if (gon.grid_params.no_edit_mode) {
                $('#grid_icon').css('display', 'none');
            }
        },
        onRender: function() {
            if (Modernizr.touch) {
                $('#grid_icon').css('opacity', '0');
            }
            document.addEventListener('fullscreenchange', function() {
                if (document.fullscreen) {
                    $('#grid_icon').css('opacity', '0');
                    $('#grid_go_fullscreen').hide();
                } else {
                    $('#grid_icon').css('opacity', '1');
                    $('#grid_go_fullscreen').show();
                }
            }, false);

            document.addEventListener('mozfullscreenchange', function() {
                if (document.mozFullScreen) {
                    $('#grid_icon').css('opacity', '0');
                    $('#grid_go_fullscreen').hide();
                } else {
                    $('#grid_icon').css('opacity', '1');
                    $('#grid_go_fullscreen').show();
                }
            }, false);

            document.addEventListener('webkitfullscreenchange', function() {
                if (document.webkitIsFullScreen) {
                    $('#grid_icon').css('opacity', '0');
                    $('#grid_go_fullscreen').hide();
                } else {
                    $('#grid_icon').css('opacity', '1');
                    $('#grid_go_fullscreen').show();
                }
            }, false);

            document.addEventListener('msfullscreenchange', function() {
                if (document.msFullscreenElement) {
                    $('#grid_icon').css('opacity', '0');
                    $('#grid_go_fullscreen').hide();
                } else {
                    $('#grid_icon').css('opacity', '1');
                    $('#grid_go_fullscreen').show();
                }
            }, false);
        }
    });

    Grid.View = App.Views.CollectionView.extend({
        template: require('./template/_grid.jst.ejs'),
        id: 'gt-grid',
        className: 'gt-grid',
        childView: Grid.Item,
        initialize: function() {
            this.on('done', this.setTimer, this);
            this.on('set:pins', this.setPins, this);
            this.on('remove:image', this.removeImage, this);
            this.on('changed:animation', this.changedAnimation, this);
            this.options.referenceCollection.on('sync', this.referenceCollectionSynced, this);
            this.collection.on('sync', this.collectionSynced, this);
        },
        childEvents: {
            'changed:pinned': 'changedPinned'
        },
        changedAnimation: function() {
            _.each(this.children._views, function(view) {
                view.changedAnimation();
            });
        },
        setPins: function() {
            var _this = this;
            _.each(gon.grid_params.pinned, function(id, index) {
                var child = this.children.findByIndex(index);
                var photoIndex = gon.starredPhotos.findIndex(function(model) {
                    return model.get('album_photo_id') === id;
                });
                if (!_.isFalsy(child) && photoIndex != -1) {
                    child.$el.toggleClass('pinned');
                    child.ui.pinPhoto.toggleClass('active');
                    child.ui.buttonsContainer.toggleClass('active');
                    child.changeImageTo(gon.starredPhotos[photoIndex], true);
                }
            }, _this);
        },
        changedPinned: function(triggerName, childView) {
            var gridIndex = this.$el.children().index(childView.$el[0]);
            gon.grid_params.pinned[gridIndex] = childView.$el.hasClass('pinned') ? childView.model.get('album_photo_id') : undefined;
            App.commands.execute('changed:pin:url');
        },
        onAddChild: function(childView) {
            this.trigger('added:image', this);
        },
        collectionSynced: function() {
            gon.currentLength = this.collection.length;
            gon.starredPhotos = this.collection.models.filter(function(photo) {
                return photo.get('is_starred');
            });
            var canPin = gon.current_user.features.indexOf('live_grid_pinning');
            if (canPin === -1 || gon.starredPhotos.length === 0) {
                _.each(this.children._views, function(view) {
                    view.triggerMethod('remove:pin');
                });
            }
            this.options.referenceCollection.next = this.collection.next;

            if (this.widgetloaded) {
                return false;
            }
            this.widgetloaded = true;
            App.execute('opened:grid', this.collection.pluck('album_photo_id'));
        },
        referenceCollectionSynced: function() {
            gon.currentLength += this.options.referenceCollection.length;
            this.options.referenceCollection.models.reverse();
            this.options.referenceCollection.each(function(model) {
                if (model.get('source_url') || model.get('data_file_name')) {
                    if (_.indexOf(gon.restricted_images, model.get('id')) === -1) {
                        gon.fresh_images.push(model);
                    }
                }
            });
            this.setTimer();
        },
        removeImage: function(model) {
            var _this = this;
            _.each(_this.children._views, function(view) {
                var activeImg = view.$el.find('.box_image.active');
                var activBg = view.$el.find('.box_bg_image.active');
                var inactiveBg = view.$el.find('.box_bg_image').not('.active');
                var inactiveImg = view.$el.find('.box_image').not('.active');

                if (activeImg.attr('src').indexOf(App.reqres.request("encode:utf8", model.get('data_file_name'))) > -1) {
                    view.newImage();
                } else if (!_.isFalsy(inactiveImg.attr('src')) && inactiveImg.attr('src').indexOf(App.reqres.request("encode:utf8", model.get('data_file_name'))) > -1) {
                    view.newImage();
                }
            });
        },
        setTimer: function() {
            var _this = this;
            clearTimeout(gon.timer);
            if (!gon.grid_params.offlineMode) {
                if (gon.refreshIterations === 0) {
                    location.reload();
                } else {
                    gon.refreshIterations--;
                }
            }
            if (gon.fresh_images.length === 0) {
                this.options.referenceCollection.reset();
                this.options.referenceCollection.models = [];

                if (!_this.options.referenceCollection.next) {
                    gon.currentLength = 0;
                    this.options.referenceCollection.goTo(1);
                    return false;
                } else {
                    this.options.referenceCollection.nextPage();
                    return false;
                }
            } else {
                gon.timer = setTimeout(function() {
                    var elems = [];
                    var videos = [];
                    var played = [];
                    _.each(_this.children._views, function(view) {
                        if (!view.$el.hasClass('gt-hidden') && !view.$el.hasClass('gt-playing') && !view.$el.hasClass('gt-waiting')) {
                            elems.push(view);
                        } else if (!view.$el.hasClass('gt-hidden') && view.$el.hasClass('gt-waiting') && !view.$el.hasClass('gt-played')) {
                            videos.push(view);
                        }
                    });
                    if (elems.length > 0) {
                        var random = Math.floor(Math.random() * elems.length);
                        elems[random].trigger('change:image');
                    }

                    if (!gon.videoPlaying && videos.length > 0) {
                        console.log('play!');
                        var random = Math.floor(Math.random() * videos.length);
                        videos[random].trigger('play:video');
                    }
                    _this.setTimer();
                }, gon.grid_params.interval);
            }

        }
    });



});